import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IActiveApi {
    exchanges?: Record<string, number>
    date?: number
    total?: number
    created_at?: number
}
export const getActiveApi = async (limit: number): Promise<ApiRes<IActiveApi[]>> => {
    return await apiGet(API_URL, `admin/api_key_count/graph?limit=${limit}`)
}
